import {
    AfterViewChecked,
    Component,
    ElementRef,
    HostListener,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import {EarthMapElement, EarthMapElementInput, ElementsFactory} from 'raain-ui';

@Component({
    selector: 'raain-globe',
    templateUrl: './raain-globe.component.html',
    styleUrls: ['./raain-globe.component.scss'],
})
export class RaainGlobeComponent implements AfterViewChecked, OnDestroy, OnChanges {
    @Input()
    public points: {
        label: string;
        style: string;
        values: {date: Date; value: number}[];
    }[];

    @Input()
    public currentHeight: number;
    public currentWidth: number;

    @ViewChild('canvasElement')
    protected canvasElement: ElementRef;

    private earthMapElement: EarthMapElement;
    private onSizeChanged;
    private created: boolean;

    constructor(private ngZone: NgZone) {
        this.onSizeChanged = () => {};
    }

    public ngAfterViewChecked(): void {
        this.create();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.change(changes);
    }

    public ngOnDestroy(): void {
        this.delete();
    }

    @HostListener('window:resize', ['$event'])
    private onResize(event: any): void {
        this.updateMapSize();
    }

    private create() {
        if (this.created) {
            return;
        }
        this.created = true;

        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                const factory = new ElementsFactory();
                try {
                    this.earthMapElement = factory.createEarthMap(
                        this.canvasElement.nativeElement,
                        new EarthMapElementInput()
                    );
                } catch (e) {
                    console.warn('Dynamic focus creation issue', e);
                }
            }, 100);
        });
    }

    private async delete() {
        // await this.earthMapElement?.destroy();
        this.created = false;
    }

    private async change(changes: SimpleChanges) {
        await this.delete();
        this.create();
    }

    private updateMapSize(): void {
        const mapDivWidth = this.canvasElement.nativeElement.parentNode?.parentNode['clientWidth'];
        const padding = 20;
        let currentWidth =
            mapDivWidth ||
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        const currentHeight =
            this.currentHeight ||
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        currentWidth -= padding;
        this.currentWidth = currentWidth;
        this.currentHeight = currentHeight;

        this.ngZone.run(() => {
            this.onSizeChanged();
        });
    }
}
